'use client';

import Image from 'next/image';
import { GitHubMark } from '@/assets/GitHubMark';
import { isGitLabProvider } from '@/hooks/useObservabilityAudit';

interface ProviderIconProps {
  provider?: string;
  className?: string;
}

/**
 * Renders the appropriate VCS provider icon based on the provider string.
 * Handles GitHub, GitLab (cloud), and self-hosted GitLab (where the provider
 * ID is the org's organization_name rather than "gitlab-self-hosted").
 */
export function ProviderIcon({
  provider,
  className = 'size-5 shrink-0',
}: ProviderIconProps) {
  if (isGitLabProvider(provider)) {
    return (
      <Image
        src="/assets/gitlab.svg"
        alt=""
        width={20}
        height={20}
        className={className}
        aria-hidden
      />
    );
  }
  return (
    <GitHubMark className={`${className} text-ds-text-default`} aria-hidden />
  );
}
